import { ReturnCarrierReconciliationTable } from "@/components/stock/return-carrier-reconciliation-table";
import { useReturnCarrierReconciliation } from "@/hooks/use-return-carrier-reconciliation";

/** Props Interface */
interface ReturnOrderCarriersProps {
	returnOrderId: string;
}

/**
 * The carrier account of the run's project: pallets and boxes out, back, still on site.
 *
 * Separate from the article panel because the two are counted differently and settled separately —
 * a site can return every pallet while still holding material, and the Leergut round that fetches
 * empties carries no articles at all.
 */
export function ReturnOrderCarriers({ returnOrderId }: ReturnOrderCarriersProps) {
	/** Query */
	const { reconciliation, isLoading, refetch, queryKey } =
		useReturnCarrierReconciliation(returnOrderId);

	/** Render */
	return (
		<ReturnCarrierReconciliationTable
			reconciliation={reconciliation}
			isLoading={isLoading}
			refetch={refetch}
			queryKey={queryKey}
			persistenceKey="return-order-carriers-table"
		/>
	);
}
